export default "__VITE_ASSET__CSK1Naoc__"